export enum AgentKnowledgeStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Disabled = "DISABLED",
}
